export default "__VITE_ASSET__DzL86lvV__"